import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import blooketIcon from "../blooket/Blooket_icon.svg";

const BlooketTool = lazy(() => import("../renderers/blooket-tool.tsx"));

export const blooketGenerator: Tool = {
    urlSlug: "blooket-generator",
    configName: "teacher-tool-blooket-generator",
    title: () => t`Blooket generator`,
    description: () => t`Create Blooket questions on a variety of topics`,
    categories: [ToolCategories.Create],
    icon: blooketIcon,
    color: color.fadedGreen24,
    layout: Layout.Blooket,
    reportingLabelId: "multiple-choice-blooket",
    exportTargets: ["blooket"],
    requestedInputs: [
        {
            description: () => "",
            inputKind: "SINGLE_SELECT",
            label: () => t`Grade level`,
            required: true,
            selectOptions: [
                {
                    label: () => t`1st grade`,
                    value: "1st grade",
                },
                {
                    label: () => t`2nd grade`,
                    value: "2nd grade",
                },
                {
                    label: () => t`3rd grade`,
                    value: "3rd grade",
                },
                {
                    label: () => t`4th grade`,
                    value: "4th grade",
                },
                {
                    label: () => t`5th grade`,
                    value: "5th grade",
                },
                {
                    label: () => t`6th grade`,
                    value: "6th grade",
                },
                {
                    label: () => t`7th grade`,
                    value: "7th grade",
                },
                {
                    label: () => t`8th grade`,
                    value: "8th grade",
                },
                {
                    label: () => t`9th grade`,
                    value: "9th grade",
                },
                {
                    label: () => t`10th grade`,
                    value: "10th grade",
                },
                {
                    label: () => t`11th grade`,
                    value: "11th grade",
                },
                {
                    label: () => t`12th grade`,
                    value: "12th grade",
                },
                {
                    label: () => t`College`,
                    value: "College",
                },
            ],
            variableName: "gradeLevel",
        },
        {
            description: () => t`e.g., Equivalent fractions`,
            inputKind: "TEXT_BOX",
            label: () => t`Topic for the Blooket question set`,
            required: true,
            variableName: "userProvidedTopic",
        },
        {
            description: () =>
                t`e.g., Understand two fractions as equivalent (equal) if they are the same size, or the same point on a number line.`,
            inputKind: "TEXT_AREA",
            label: () => t`Standards or learning objectives`,
            variableName: "userProvidedStandards",
        },
        {
            description: () => t`e.g., Focus on single digit fractions.`,
            inputKind: "TEXT_AREA",
            label: () => t`Additional notes for the topic`,
            variableName: "userProvidedNotes",
        },
        {
            description: () =>
                t`e.g., Phrase the questions/answers in Jeopardy format; Talk like a pirate`,
            inputKind: "TEXT_BOX",
            label: () => t`Overall instructions for the Blooket question set`,
            variableName: "additionalInstructions",
        },
    ],
    component: ({persona, configName, providedInputs}) => {
        return (
            <BlooketTool
                persona={persona}
                configName={configName}
                providedInputs={providedInputs}
            />
        );
    },
};
